import React from 'react';

import IconAction from '../IconAction';
import { topNavActionPlacement } from '../shared/topNavActionPlacement';
import { telemetryClickHandler } from '../telemetryHandler';
import type { ActionItemConfig } from '../types';

interface DesktopNavActionsProps {
  items: ActionItemConfig[];
}

export default function DesktopNavActions({
  items,
}: DesktopNavActionsProps): JSX.Element {
  return (
    <div className="hidden items-center gap-6 topnav-md:flex">
      {items.map((item) => {
        if (item.type === 'link') {
          return (
            <a
              key={item.href}
              href={item.href}
              data-cta={topNavActionPlacement(item.href)}
              className="text-base font-normal text-gray-900 hover:opacity-80 no-underline"
              onClick={telemetryClickHandler(
                item.telemetrySlug,
                item.telemetryEvents
              )}
            >
              {item.label}
            </a>
          );
        }

        if (item.type === 'cta') {
          return (
            <a
              key={item.href}
              href={item.href}
              data-cta={topNavActionPlacement(item.href)}
              className="flex h-10 items-center justify-center rounded-10px bg-yellow-400 px-6 text-sm font-semibold text-gray-900 hover:bg-yellow-500 no-underline"
              onClick={telemetryClickHandler(
                item.telemetrySlug,
                item.telemetryEvents
              )}
            >
              {item.label}
            </a>
          );
        }

        return (
          <IconAction
            key={item.href}
            item={item}
            linkLabelClassName="ml-2 text-base font-semibold text-gray-900"
          />
        );
      })}
    </div>
  );
}
